/* LaFarmacia - desplegable del buscador (estilo Atida)
   Escritorio: panel bajo la barra (busquedas populares / categorias | productos).
   Movil: pantalla completa con flecha para volver.

   Los resultados de PRODUCTOS salen del buscador inteligente (Railway, via
   el App Proxy /apps/buscador): entiende sinonimos, sintomas, siglas de
   ingredientes y significado (no solo palabras literales). Railway ya
   sincroniza precio, precio de comparacion e imagen de cada producto desde
   Shopify (ver cargarCatalogo() e index.js del lado del servidor, que se
   mantiene al dia con webhooks casi al instante ante cambios de precio o
   bajas), asi que vienen directo en la misma respuesta: antes esto se
   pedia aparte, por cada producto a mostrar, a /products/{handle}.js
   (publico), lo que sumaba una tanda extra de pedidos -y de espera- por
   cada busqueda. Sacar ese paso es lo que antes tardaba entre medio
   segundo y un segundo de mas en el desplegable.

   VELOCIDAD (busqueda rapida primero, IA solo si hace falta): Railway
   expone dos rutas. /apps/buscador/rapido responde en milisegundos (solo
   coincidencia de palabras + sinonimos, sin llamar a ninguna IA externa) y
   /apps/buscador responde mas lento pero mas completo (agrega busqueda por
   significado, alternativas de otras marcas, tintes de fantasia e
   interpretacion de siglas via IA). Se piden las dos en paralelo apenas el
   cliente escribe: la rapida se muestra apenas llega (como el buscador de
   Atida, practicamente al instante), y si la propia Railway indica que esa
   respuesta rapida ya es suficiente (bandera "suficiente"), ahi termina: no
   se espera nada mas. Si la rapida no alcanzo (pocos o ningun resultado, o
   la consulta necesita interpretacion), se espera tambien la completa y se
   reemplaza el panel con ese resultado mejorado en cuanto llega.

   Las "busquedas populares" y "categorias" del panel siguen viniendo del
   buscador nativo de Shopify (/search/suggest), que sigue sirviendo bien
   para eso. Si Railway no responde a tiempo (caido, sincronizando, o la
   red del cliente falla), se usa el buscador nativo como respaldo para
   que el desplegable nunca se quede sin resultados de productos. */
(function(){
  if(window.__lafPS) return; window.__lafPS = true;

  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* Formatea centavos a euros, estilo España (1.234,56 €). La tienda opera
     en EUR (lafarmacia.es); si mas adelante se necesitara soporte multi-
     moneda real, esto deberia leerse de Shopify.currency en vez de fijo. */
  function formatMoney(cents){
    var value = (Number(cents) || 0) / 100;
    var txt = value.toLocaleString('es-ES', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return txt + ' €';
  }

  function resizeImg(url, width){
    if(!url) return '';
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'width=' + width;
  }

  function escapeHtml(str){
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* Misma regla de marca que snippets/lf-search-filter.liquid (se repite
     aca porque estos productos no pasan por Liquid). El filtro por SKU
     (muestras/uso interno) que antes se hacia aca tambien, ahora se hace
     del lado de Railway, al armar el catalogo (ver productoDebeOcultarse en
     index.js): esos productos directamente no llegan a estar en los
     resultados que devuelve Railway, asi que ya no hace falta el SKU aca
     (tampoco viene: ver comentario grande arriba de por que). Esta
     verificacion por marca se deja como respaldo, sin costo, porque el dato
     ya viene en la respuesta. */
  function debeOcultarse(producto){
    var vendor = producto.vendor || '';
    return vendor === 'Luxmetique';
  }

  function filaProducto(producto){
    var img = producto.featured_image
      ? '<img src="' + escapeHtml(resizeImg(producto.featured_image, 140)) + '" alt="" width="60" height="60" loading="lazy">'
      : '';
    var sub = producto.vendor
      ? '<span class="laf-ps__sub">' + escapeHtml(producto.vendor) + '</span>'
      : '';
    var tachado = (producto.compare_at_price && producto.compare_at_price > producto.price)
      ? '<s>' + formatMoney(producto.compare_at_price) + '</s>'
      : '';
    return (
      '<li><a class="laf-ps__prod" href="' + escapeHtml(producto.url) + '">' +
        '<span class="laf-ps__img">' + img + '</span>' +
        '<span class="laf-ps__info"><span class="laf-ps__name">' + escapeHtml(producto.title) + '</span>' + sub + '</span>' +
        '<span class="laf-ps__price">' + tachado + '<b>' + formatMoney(producto.price) + '</b></span>' +
      '</a></li>'
    );
  }

  /* Tiempo maximo de espera a la busqueda COMPLETA (con IA) antes de
     resignarse y usar el respaldo nativo: si Railway esta lento (por
     ejemplo durante una resincronizacion del catalogo) no tiene sentido
     hacer esperar al cliente mas de esto. Solo aplica cuando la busqueda
     rapida no alcanzo (ver mas abajo); cuando si alcanza, no se espera
     nada de esto. */
  var TIEMPO_MAXIMO_INTELIGENTE_MS = 6000;

  /* Tiempo maximo de espera a la busqueda RAPIDA (sin IA): es lexica pura,
     deberia responder en milisegundos siempre, asi que el limite es corto;
     si ni siquiera esta responde a tiempo, se cae directo al respaldo
     nativo mientras se sigue esperando la completa en paralelo. */
  var TIEMPO_MAXIMO_RAPIDO_MS = 1500;

  /* Tiempo de pausa sin escribir para dar por "terminada" una busqueda y
     recien ahi registrarla (para el informe semanal de terminos buscados).
     Bastante mas largo que el debounce de la busqueda en si (100ms): ese es
     corto a proposito para que el desplegable se sienta instantaneo, pero
     usarlo tambien para registrar dejaria el registro lleno de fragmentos
     sueltos de cada letra tipeada ("c", "ce", "cer"...) en vez del termino
     real que el cliente tenia en mente. */
  var TIEMPO_LOG_MS = 900;

  /* Dado el resultado crudo de Railway (rapido o completo), arma el HTML de
     la columna de productos. Railway ya trae precio/precio de comparacion/
     imagen de cada uno (sincronizados desde Shopify, ver comentario grande
     arriba), asi que esto es puramente sincrono: ya no hace falta pedir
     nada mas a Shopify por producto antes de poder mostrar el desplegable.
     Se mantiene como Promise (resuelta al toque) para no tener que tocar
     donde se la llama, que sigue encadenando ".then(...)". */
  function armarProductosDesdeResultado(data){
    // Exige precio ademas de handle/titulo: si por lo que sea Railway no
    // llego a sincronizar el precio de un producto (dato incompleto, recien
    // creado un instante antes de que llegue su webhook, etc.), mejor no
    // mostrarlo en el desplegable a mostrar "0,00 €" en su lugar. En la
    // pagina de resultados final igual aparece bien, con el precio real
    // pedido en el momento por el buscador nativo de Shopify.
    var resultados = (data.resultados || []).filter(function(r){ return r.handle && r.titulo && r.precio != null; });
    if(resultados.length === 0) return Promise.resolve({html: '', total: 0, mostrados: 0});

    // Se muestran los primeros 4; el resto solo importa para "Ver todos los
    // resultados de...".
    var aMostrar = resultados.slice(0, 4);
    var filas = '';
    var mostrados = 0;
    var handles = [];
    for(var i = 0; i < aMostrar.length; i++){
      var r = aMostrar[i];
      var producto = {
        title: r.titulo,
        vendor: r.marca,
        url: root() + 'products/' + r.handle,
        featured_image: r.imagen,
        price: r.precio,
        compare_at_price: r.precio_comparacion
      };
      if(debeOcultarse(producto)) continue;
      filas += filaProducto(producto);
      handles.push(r.handle);
      mostrados++;
    }
    return Promise.resolve({html: filas, total: data.total || resultados.length, mostrados: mostrados, handles: handles});
  }

  /* Pide una ruta de Railway con su propio tiempo maximo de espera.
     Devuelve la respuesta JSON ya parseada, o rechaza si tarda demasiado,
     falla la red, o la respuesta no es valida. */
  function pedirRailway(path, q, signalExterno, tiempoMaximoMs){
    var ctrlPropio = window.AbortController ? new AbortController() : null;
    var vencido = false;
    var temporizador = setTimeout(function(){
      vencido = true;
      if(ctrlPropio){ try{ ctrlPropio.abort(); }catch(e){} }
    }, tiempoMaximoMs);

    if(signalExterno){
      // Si la consulta externa se cancela (el cliente siguio escribiendo),
      // se cancela tambien esta.
      signalExterno.addEventListener('abort', function(){
        if(ctrlPropio){ try{ ctrlPropio.abort(); }catch(e){} }
      });
    }

    var signal = ctrlPropio ? ctrlPropio.signal : signalExterno;
    var url = root() + path + '?query=' + encodeURIComponent(q);
    return fetch(url, {signal: signal})
      .then(function(r){ if(!r.ok){ throw new Error('HTTP ' + r.status); } return r.json(); })
      .then(function(data){
        if(!data || data.ok !== true) throw new Error('respuesta invalida de ' + path);
        clearTimeout(temporizador);
        return {data: data, signal: signal};
      })
      .catch(function(err){
        clearTimeout(temporizador);
        if(vencido){ throw new Error(path + ' tardo demasiado'); }
        throw err;
      });
  }

  /* Terminos que Railway devolvio para cada consulta ya pedida (ver
     "terminos_usados" en buscador.js del lado del servidor): el primer
     elemento siempre es la consulta tal cual la escribio el cliente, y el
     resto -si los hay- son los que agrego el diccionario de sintomas o
     sinonimos (ya bien escritos). Se usa para mejorar la consulta que se
     le manda al buscador NATIVO de Shopify al enviar el formulario (ver
     consultaParaShopify): el nativo no conoce ese diccionario, asi que si
     no se le entrega esto el error de tipeo o el sintoma coloquial le
     llega tal cual y no lo entiende. */
  var terminosPorConsulta = {};

  /* Cuantos resultados dio la ultima respuesta de Railway para cada
     consulta (para registrarlo junto con el termino en el informe
     semanal). Se guarda aparte de terminosPorConsulta porque este si se
     actualiza con CUALQUIER respuesta (rapida o completa), incluso cuando
     esa respuesta no trajo terminos extra del diccionario. */
  var totalPorConsulta = {};

  /* Handles de los productos que la vista previa mostro para cada consulta. */
  var handlesPorConsulta = {};

  /* Busqueda RAPIDA: solo coincidencia de palabras (sin IA), responde en
     milisegundos. Devuelve {html, total, mostrados, suficiente} o null si
     no esta disponible ahora mismo. */
  function pedirProductosRapido(q, signalExterno){
    return pedirRailway('apps/buscador/rapido', q, signalExterno, TIEMPO_MAXIMO_RAPIDO_MS)
      .then(function(res){
        if(res.data.terminos_usados) terminosPorConsulta[q] = res.data.terminos_usados;
        if(typeof res.data.total === 'number') totalPorConsulta[q] = res.data.total;
        return armarProductosDesdeResultado(res.data, res.signal).then(function(armado){
          armado.suficiente = !!res.data.suficiente;
          if(armado.handles && armado.handles.length) handlesPorConsulta[q] = armado.handles;
          return armado;
        });
      });
  }

  /* Busqueda COMPLETA: coincidencia de palabras + significado (IA) +
     alternativas de marca + tinte de fantasia + interpretacion de siglas.
     Mas lenta (llama a OpenAI del lado de Railway). Devuelve {html, total,
     mostrados} o null si no esta disponible ahora. */
  function pedirProductosCompleto(q, signalExterno){
    return pedirRailway('apps/buscador', q, signalExterno, TIEMPO_MAXIMO_INTELIGENTE_MS)
      .then(function(res){
        if(res.data.terminos_usados) terminosPorConsulta[q] = res.data.terminos_usados;
        if(typeof res.data.total === 'number') totalPorConsulta[q] = res.data.total;
        return armarProductosDesdeResultado(res.data, res.signal).then(function(armado){
          if(armado.handles && armado.handles.length) handlesPorConsulta[q] = armado.handles;
          return armado;
        });
      });
  }

  /* Deja registrado, para el informe semanal, que se busco este termino y
     cuantos resultados encontro -nada mas: ni clics en productos, ni
     compras, ni ningun dato que identifique al cliente (asi se definio con
     Claudia)-. Se llama recien cuando el cliente deja de escribir un rato
     (ver TIEMPO_LOG_MS mas arriba), o al confirmar la busqueda (Enter, o
     "Mostrar mas resultados"): nunca en cada letra tipeada, porque si no el
     "termino mas buscado" terminaria siendo siempre una letra suelta.
     "yaRegistrado" evita registrar dos veces la misma consulta exacta
     dentro de esta misma visita a la pagina (por ejemplo, si el temporizador
     y el envio del formulario coinciden para la misma busqueda). Se ignora
     cualquier error de red: esto es solo estadistica, nunca debe afectar la
     busqueda real del cliente. keepalive:true para que el pedido llegue
     igual si la pagina ya esta navegando (al tocar "Mostrar mas
     resultados", por ejemplo). */
  var yaRegistrado = {};
  function registrarBusqueda(q){
    if(!q || yaRegistrado[q]) return;
    var total = totalPorConsulta[q];
    if(total == null) return; // todavia no sabemos cuantos resultados dio esta consulta
    yaRegistrado[q] = true;
    var url = root() + 'apps/buscador/registrar?query=' + encodeURIComponent(q) + '&resultados=' + encodeURIComponent(total);
    try{ fetch(url, {keepalive: true}).catch(function(){}); }catch(e){}
  }

  /* Dada la consulta tal cual la escribio el cliente, arma la consulta que
     realmente conviene mandarle al buscador NATIVO de Shopify (el que
     arma la pagina final de resultados en /search): si Railway ya
     encontro, para esta consulta, terminos del diccionario de sintomas/
     sinonimos (ver terminosPorConsulta arriba), se le pide al nativo esos
     terminos -ya bien escritos y literales- en vez del texto tal cual lo
     tipeo el cliente. Asi, un error de tipeo en un sintoma ("dilor de
     oreja") o un sintoma correctamente escrito pero que el nativo no
     asocia a nada ("dolor de oido") le llegan ya traducidos a lo que
     realmente hay que buscar (ibuprofeno, gotas oticas, etc.), en vez de
     depender del propio criterio -mucho mas limitado, y a veces
     directamente erroneo: "dilor" el nativo lo autocorrige a la marca
     "Dior"- del buscador nativo. Si no hay terminos extra (busqueda
     normal de producto/marca), se devuelve la consulta sin tocar.*/
  /* Los productos que el cliente ya vio en la vista previa viajan en la URL
     de "Mostrar mas resultados" (lf_top=handle1,handle2,...): la pagina de
     resultados (assets/laf-search.js) los pone PRIMERO y despues muestra el
     resto, asi nunca desaparecen los que se vieron en la vista previa. */
  function parametroDestacados(handles){
    if(!handles || !handles.length) return '';
    return '&lf_top=' + encodeURIComponent(handles.slice(0, 12).join(','));
  }

  function consultaParaShopify(q){
    var terminos = terminosPorConsulta[q];
    if(!terminos || terminos.length <= 1) return q;
    var extra = terminos.slice(1);
    return extra.map(function(t){ return t.indexOf(' ') > -1 ? '"' + t + '"' : t; }).join(' OR ');
  }

  /* Buscador nativo de Shopify: se usa para "busquedas populares" /
     "categorias" del panel (sigue funcionando bien para eso), y como
     respaldo de productos si el buscador inteligente no responde. */
  function pedirPanelNativo(q, signal){
    var url = root() + 'search/suggest?q=' + encodeURIComponent(q) +
      '&section_id=laf-predictive' +
      '&resources[type]=product,query,collection' +
      '&resources[limit]=10&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,variants.title';
    return fetch(url, {signal: signal})
      .then(function(r){ if(!r.ok){ throw new Error('HTTP ' + r.status); } return r.text(); })
      .then(function(text){
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var el = doc.getElementById('laf-ps-results');
        return el ? el.outerHTML : '';
      });
  }

  function init(box){
    if(!box || box.__lafPS) return; box.__lafPS = true;
    var input = box.querySelector('.laf-search__input');
    var panel = box.querySelector('.laf-ps');
    var def = box.querySelector('.laf-ps__default');
    var live = box.querySelector('.laf-ps__live');
    if(!input || !panel || !def || !live) return;

    var cache = {}, ctrl = null, timer = null, logTimer = null, shownQ = null;
    var mobile = window.matchMedia('(max-width:749px)');

    /* Respaldo del alto real de pantalla mientras el panel esta abierto en
       movil: algunos navegadores embebidos (por ejemplo el previsualizador
       de temas dentro de la app de Shopify) no achican 100dvh cuando
       aparece el teclado, y eso dejaba la barra de busqueda tapada o fuera
       de la pantalla apenas se empezaba a escribir. window.visualViewport
       si refleja el alto visible real (con teclado abierto o cerrado) de
       forma consistente, asi que se usa para fijar --laf-vvh en vivo. */
    var vv = window.visualViewport;
    function syncVV(){
      if(!vv || !mobile.matches) return;
      document.documentElement.style.setProperty('--laf-vvh', vv.height + 'px');
    }

    /* La barra vive dentro de la cabecera (que en movil es "sticky"). En
       algunos navegadores basados en WebKit (confirmado en el
       previsualizador de temas de la app de Shopify) esa cabecera "sticky"
       arma su propio contexto de apilamiento y, con el teclado abierto,
       termina tapando el buscador de pantalla completa aunque su z-index
       sea enorme -es la misma familia de bug que Dawn ya documenta para
       Safari en header.liquid ("PR #2147")-. La solucion definitiva es
       sacar el buscador de ahi: mientras esta abierto en movil se mueve
       directo a <body> (al final del documento, sin ningun ancestro
       sticky/con su propio z-index de por medio) y, al cerrarlo, se
       devuelve exactamente a su lugar original marcado por "marcador". */
    var marcador = document.createComment('laf-search-lugar-original');
    var enBody = false;
    function sacarDeLaCabecera(){
      if(enBody || !box.parentNode) return;
      // Mover un nodo del DOM que contiene el elemento enfocado le quita el
      // foco (es asi en todos los navegadores): en el celular eso cierra el
      // teclado de inmediato y la persona no puede seguir escribiendo. Por
      // eso, si el campo tenia el foco justo antes de moverlo, se lo
      // devolvemos apenas termina el movimiento (mismo evento, sin demora,
      // para que el teclado no llegue a cerrarse).
      var teniaFoco = document.activeElement === input;
      var seleccion = teniaFoco ? [input.selectionStart, input.selectionEnd] : null;
      box.parentNode.insertBefore(marcador, box);
      document.body.appendChild(box);
      enBody = true;
      if(teniaFoco){
        input.focus({preventScroll: true});
        if(seleccion && input.setSelectionRange){
          try{ input.setSelectionRange(seleccion[0], seleccion[1]); }catch(e){}
        }
      }
    }
    function devolverALaCabecera(){
      if(!enBody || !marcador.parentNode) return;
      marcador.parentNode.insertBefore(box, marcador);
      marcador.parentNode.removeChild(marcador);
      enBody = false;
    }

    function isOpen(){ return box.classList.contains('is-open'); }
    function open(){
      if(isOpen()) return;
      box.classList.add('is-open');
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('laf-ps-open');
      if(mobile.matches){
        document.body.style.overflow = 'hidden';
        sacarDeLaCabecera();
        syncVV();
        if(vv){ vv.addEventListener('resize', syncVV); vv.addEventListener('scroll', syncVV); }
      }
      update();
    }
    function close(){
      if(!isOpen()) return;
      box.classList.remove('is-open', 'is-loading');
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('laf-ps-open');
      document.body.style.overflow = '';
      if(vv){ vv.removeEventListener('resize', syncVV); vv.removeEventListener('scroll', syncVV); }
      document.documentElement.style.removeProperty('--laf-vvh');
      devolverALaCabecera();
    }
    function showDefault(){ def.hidden = false; live.hidden = true; shownQ = null; }
    function show(q, html){
      if(input.value.trim() !== q) return;
      live.innerHTML = html; live.hidden = false; def.hidden = true; shownQ = q;
      panel.scrollTop = 0;
    }

    /* Arma el panel final combinando: la columna izquierda (busquedas
       populares/categorias) del buscador nativo, con la columna derecha
       (productos) del buscador inteligente. Si el inteligente falla, cae
       a los productos del nativo (columna derecha ya viene armada ahi). */
    function armarPanel(q, htmlNativo, productosInteligente){
      var wrap = document.createElement('div');
      wrap.innerHTML = htmlNativo || '';
      var contenedor = wrap.querySelector('#laf-ps-results');
      if(!contenedor){
        // El nativo no devolvio nada utilizable: no hay panel que mostrar.
        return '';
      }
      if(productosInteligente){
        var colDerecha = contenedor.querySelector('.laf-ps__col--right');
        if(colDerecha){
          var listaHtml = productosInteligente.mostrados > 0
            ? '<ul class="laf-ps__list">' + productosInteligente.html + '</ul>'
            : '<p class="laf-ps__empty">No encontramos productos para «' + escapeHtml(q) + '». Prueba con otra palabra o con la marca.</p>';
          colDerecha.innerHTML =
            '<p class="laf-ps__h">Productos</p>' + listaHtml +
            '<a class="laf-ps__all" href="' + root() + 'search?q=' + encodeURIComponent(consultaParaShopify(q)) + '&options%5Bprefix%5D=last' + parametroDestacados(productosInteligente.handles) + '">Mostrar más resultados</a>';
        }
      }
      return contenedor.outerHTML;
    }

    /* Busqueda rapida primero, IA solo si hace falta: se piden panel nativo
       + rapida + completa los TRES en paralelo desde el arranque (pedir la
       completa recien despues de ver que la rapida no alcanzo perderia el
       tiempo que ya llevaba corriendo en el servidor). Se muestra apenas
       estan el nativo y la rapida listos -eso ya alcanza en la mayoria de
       los casos, como en Atida-. Solo si Railway dice que la rapida NO fue
       suficiente (sigla, sinonimo, marca sin alternativas, etc.) se espera
       tambien la completa y se reemplaza la columna de productos cuando
       llega, sin tocar el resto del panel ni hacer parpadear la busqueda
       ya mostrada. */
    function fetchQ(q){
      if(ctrl){ try{ ctrl.abort(); }catch(e){} }
      ctrl = window.AbortController ? new AbortController() : null;
      var signal = ctrl ? ctrl.signal : undefined;
      box.classList.add('is-loading');

      var promesaCompleta = pedirProductosCompleto(q, signal).catch(function(){ return null; });

      Promise.all([
        pedirPanelNativo(q, signal),
        pedirProductosRapido(q, signal).catch(function(){ return null; }),
      ]).then(function(res){
        var htmlNativo = res[0];
        var productosRapido = res[1];
        var html = armarPanel(q, htmlNativo, productosRapido);
        cache[q] = html;
        box.classList.remove('is-loading');
        if(html){ show(q, html); }

        var yaAlcanzo = productosRapido && productosRapido.suficiente;
        if(yaAlcanzo) return;

        // La rapida no alcanzo: se espera la completa (que ya venia
        // corriendo desde el principio) y se reemplaza solo la columna de
        // productos cuando llega, si el cliente sigue en la misma consulta.
        promesaCompleta.then(function(productosCompleto){
          if(!productosCompleto) return;
          var htmlMejorado = armarPanel(q, htmlNativo, productosCompleto);
          if(!htmlMejorado) return;
          cache[q] = htmlMejorado;
          if(input.value.trim() === q){ show(q, htmlMejorado); }
        });
      }).catch(function(err){
        if(err && err.name === 'AbortError') return;
        box.classList.remove('is-loading');
      });
    }
    function update(){
      var q = input.value.trim();
      clearTimeout(timer);
      clearTimeout(logTimer);
      if(q.length < 2){
        if(ctrl){ try{ ctrl.abort(); }catch(e){} ctrl = null; }
        box.classList.remove('is-loading');
        showDefault(); return;
      }
      // Se reprograma con cada letra: solo llega a dispararse cuando el
      // cliente deja de escribir TIEMPO_LOG_MS sin tocar el teclado (ver su
      // definicion mas arriba), que es la señal de que esa es la busqueda
      // "final" que tenia en mente.
      logTimer = setTimeout(function(){ registrarBusqueda(q); }, TIEMPO_LOG_MS);
      if(q === shownQ) return;
      if(cache[q] !== undefined){ show(q, cache[q]); return; }
      // Tiempo de espera antes de disparar la busqueda mientras el cliente
      // sigue escribiendo (evita pedir una busqueda por cada letra tipeada).
      // Se bajo de 180ms a 100ms: el buscador inteligente (Railway) ya
      // toma su propio tiempo en responder (1-1.5s tipico), asi que no
      // tiene sentido sumarle mucho mas de espera artificial antes de
      // siquiera empezar a pedirlo.
      timer = setTimeout(function(){ fetchQ(q); }, 100);
    }

    /* se abre solo cuando se empieza a escribir (no al pulsar en la barra) */
    input.addEventListener('input', function(){
      if(!input.value.trim()){ close(); return; }
      if(!isOpen()){ open(); } else { update(); }
    });

    /* Al enviar el formulario (Enter, o tocar la lupa) se navega a la
       pagina de resultados de Shopify, que usa el buscador NATIVO (no el
       inteligente de Railway): por eso, si ya sabemos -por lo que se pidio
       mientras el cliente escribia- que esta consulta corresponde a un
       sintoma o tiene un termino del diccionario de sinonimos, se corrige
       la consulta ANTES de que se envie, para que el nativo reciba algo
       que si va a entender (ver consultaParaShopify). Si no hay nada que
       corregir, se deja el envio tal cual, sin agregar ninguna espera. */
    var form = box.querySelector('.laf-search__form');
    if(form){
      form.addEventListener('submit', function(e){
        var q = input.value.trim();
        if(!q) return;
        // Se confirma la busqueda (Enter/lupa): se registra ya mismo, sin
        // esperar la pausa de TIEMPO_LOG_MS (ver registrarBusqueda), porque
        // esto YA es la señal de que el cliente termino de decidir que
        // buscar.
        clearTimeout(logTimer);
        registrarBusqueda(q);
        var qFinal = consultaParaShopify(q);
        var extraTop = parametroDestacados(handlesPorConsulta[q]);
        if(qFinal === q && !extraTop) return;
        e.preventDefault();
        window.location.href = root() + 'search?q=' + encodeURIComponent(qFinal) + '&options%5Bprefix%5D=last' + extraTop;
      });
    }

    /* cerrar: flecha (movil), fondo oscuro (escritorio), Esc, clic fuera */
    box.addEventListener('click', function(e){
      if(e.target.closest('[data-laf-ps-close]')){ e.preventDefault(); close(); input.blur(); }
      // Tocar "Mostrar mas resultados" tambien confirma la busqueda: se
      // registra ya (shownQ es la consulta cuyos resultados estan
      // mostrados en este momento, la misma para la que ya se conoce el
      // total).
      if(e.target.closest('.laf-ps__all')){ clearTimeout(logTimer); registrarBusqueda(shownQ); }
    });
    document.addEventListener('click', function(e){ if(isOpen() && !box.contains(e.target)){ close(); } });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && isOpen()){ close(); input.blur(); }
    });

    /* flechas del teclado para moverse por el desplegable */
    function links(){
      var scope = live.hidden ? def : live;
      return Array.prototype.slice.call(scope.querySelectorAll('a'));
    }
    box.addEventListener('keydown', function(e){
      if(!isOpen() || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      var l = links(); if(!l.length) return;
      var i = l.indexOf(document.activeElement);
      e.preventDefault();
      if(e.key === 'ArrowDown'){ (i < 0 ? l[0] : l[Math.min(i + 1, l.length - 1)]).focus(); }
      else { if(i <= 0){ input.focus(); } else { l[i - 1].focus(); } }
    });

    /* al volver atras en el navegador con el panel abierto */
    window.addEventListener('pageshow', function(){ close(); });
  }

  /* la misma barra se reutiliza en otras paginas (p. ej. resultados de busqueda en movil) */
  window.lafPS = { init: init };
  function start(){ Array.prototype.forEach.call(document.querySelectorAll('[data-laf-ps]'), init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
